// Auto-generated from .env.local by scripts/sync-env.mjs
export const environment = {
  "SUPABASE_URL": "https://mempostlasqtnejkjuoa.supabase.co",
  "SUPABASE_ANON_KEY": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1lbXBvc3RsYXNxdG5lamtqdW9hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ0NjI0MDYsImV4cCI6MjA5MDAzODQwNn0.NeWXe6zWb6cq3FPgdnpAEjDj55s2UsFPYOUwuS9pLeE"
} as const;
